import { call, options, params } from './helpers';

// Get all KB articles
export const getKbArticles = (payload) => call(`/beta/knowledge-base${params(payload)}`);

// Get published articles only (for power users / public view)
export const getPublishedArticles = (payload) => call(`/beta/knowledge-base/published${params(payload)}`);

// Get single KB article
export const getKbArticle = ({ id }) => call(`/beta/knowledge-base/${id}`);

// Create new KB article
export const createKbArticle = (payload) =>
	call(`/beta/knowledge-base`, options(payload, 'POST'));

// Create KB article from resolved ticket
export const createKbArticleFromTicket = ({ ticketId, ...payload }) =>
	call(`/beta/knowledge-base/from-ticket/${ticketId}`, options(payload, 'POST'));

// Update KB article
export const updateKbArticle = ({ id, ...payload }) =>
	call(`/beta/knowledge-base/${id}`, options(payload, 'PUT'));

// Delete KB article
export const deleteKbArticle = ({ id }) =>
	call(`/beta/knowledge-base/${id}`, options(null, 'DELETE'));

// Publish KB article
export const publishKbArticle = ({ id }) =>
	call(`/beta/knowledge-base/${id}/publish`, options({}, 'POST'));

// Archive KB article
export const archiveKbArticle = ({ id }) =>
	call(`/beta/knowledge-base/${id}/archive`, options({}, 'POST'));

// Restore KB article
export const restoreKbArticle = ({ id }) =>
	call(`/beta/knowledge-base/${id}/restore`, options({}, 'POST'));

// Get available categories
export const getKbCategories = () => call(`/beta/knowledge-base/categories`);

// Get common tags
export const getKbTags = () => call(`/beta/knowledge-base/tags`);

// Get templates
export const getKbTemplates = () => call(`/beta/knowledge-base/templates`);

// Get single template
export const getKbTemplate = ({ id }) => call(`/beta/knowledge-base/templates/${id}`);

// Get suggested articles for an asset
export const getKbSuggestions = ({ assetId }) => call(`/beta/knowledge-base/suggestions?assetId=${assetId}`);

// Track article view
export const trackKbArticleView = ({ id }) =>
	call(`/beta/knowledge-base/${id}/view`, options({}, 'POST'));

// Ticket linking
export const getKbArticleTickets = ({ id }) => call(`/beta/knowledge-base/${id}/tickets`);

export const linkKbArticleTicket = ({ id, ticketId, linkType }) =>
	call(`/beta/knowledge-base/${id}/tickets`, options({ ticketId, linkType }, 'POST'));

export const unlinkKbArticleTicket = ({ id, ticketId }) =>
	call(`/beta/knowledge-base/${id}/tickets/${ticketId}`, options(null, 'DELETE'));

// Document management
export const getKbArticleDocuments = ({ id }) => call(`/beta/knowledge-base/${id}/documents`);

export const attachKbArticleDocuments = ({ id, documentIds }) =>
	call(`/beta/knowledge-base/${id}/documents`, options({ documentIds }, 'POST'));

export const removeKbArticleDocument = ({ id, documentId }) =>
	call(`/beta/knowledge-base/${id}/documents/${documentId}`, options(null, 'DELETE'));

// Related articles
export const getKbRelatedArticles = ({ id }) => call(`/beta/knowledge-base/${id}/related`);

export const addKbRelatedArticle = ({ id, relatedArticleId, relationType }) =>
	call(`/beta/knowledge-base/${id}/related`, options({ relatedArticleId, relationType }, 'POST'));

export const removeKbRelatedArticle = ({ id, relatedArticleId }) =>
	call(`/beta/knowledge-base/${id}/related/${relatedArticleId}`, options(null, 'DELETE'));

// Upload image for KB content
export const uploadKbImage = async (file) => {
	const formData = new FormData();
	formData.append('file', file);

	const user = JSON.parse(localStorage.getItem('user'));

	const response = await fetch(`${process.env.API_URL}/beta/knowledge-base/upload-image`, {
		method: 'POST',
		headers: {
			...(user?.jwtToken ? { Authorization: `Bearer ${user.jwtToken}` } : {}),
		},
		body: formData,
	});

	if (!response.ok) {
		throw new Error('Failed to upload image');
	}

	return response.json();
};

// Upload attachment for KB article
export const uploadKbAttachment = async (file) => {
	const formData = new FormData();
	formData.append('file', file);

	const user = JSON.parse(localStorage.getItem('user'));

	const response = await fetch(`${process.env.API_URL}/beta/knowledge-base/upload-attachment`, {
		method: 'POST',
		headers: {
			...(user?.jwtToken ? { Authorization: `Bearer ${user.jwtToken}` } : {}),
		},
		body: formData,
	});

	if (!response.ok) {
		throw new Error('Failed to upload attachment');
	}

	return response.json();
};
